var SDK_VERSION = '7.41.0';
export { SDK_VERSION };